import { api } from './client';

export interface EmailLogItem {
  id: string;
  created_at: string | null;
  to_addr: string;
  subject: string;
  kind: string;
  ticket_id: string | null;
  ticket_number: string | null;
  send_status: 'sent' | 'failed' | 'skipped' | string;
  reason: string;
  delivery_status: 'unknown' | 'delivered' | 'deferred' | 'bounced' | 'no_data' | string;
  delivery_detail: string;
  delivery_checked_at: string | null;
}

export interface EmailLogResp {
  items: EmailLogItem[];
  total: number;
  counters: Record<string, number>;
}

export const emailLogApi = {
  list: (params?: { limit?: number; send_status?: string; delivery_status?: string; q?: string }) =>
    api.get<EmailLogResp>('/api/v1/admin/email-log', { params }).then(r => r.data),
  refresh: () =>
    api.post<{ updated: number }>('/api/v1/admin/email-log/refresh').then(r => r.data),
};
